import JobServePartialCvDetail from '../types/JobServePartialCvDetail';

export const processPartialCvDetailResponse = (response: any): JobServePartialCvDetail => {
  const modifiedResponse: JobServePartialCvDetail = {
    candidateId: '',
    partialCvDetail: {
      RoleSought: '',
      Skills: '',
      Availability: '',
    },
  };
  if (response?.Envelope?.Body?.FullDetailsResult) {
    modifiedResponse.candidateId = response.Envelope.Body.FullDetailsResult.CVID;
    if (modifiedResponse.partialCvDetail) {
      modifiedResponse.partialCvDetail.RoleSought =
        response.Envelope.Body.FullDetailsResult.RoleSought;
      modifiedResponse.partialCvDetail.Skills = response.Envelope.Body.FullDetailsResult.Skills;
      modifiedResponse.partialCvDetail.Availability =
        response.Envelope.Body.FullDetailsResult.Availability;
    }
  }
  return modifiedResponse;
};
